export default __webpack_public_path__ + "static/media/no-break.c1d2b49c.png";